import React, { useState, useRef, useEffect } from 'react';
import '../../index.css';
import landing from '../../assets/land.webm';

const FadeInImage = () => {
  const [loaded, setLoaded] = useState(false);
  const [fadeCompleted, setFadeCompleted] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      const handleLoadedData = () => {
        setLoaded(true);
        // After 2.5 seconds, remove the black background (same as video fade duration)
        setTimeout(() => setFadeCompleted(true), 2500);
      };

      videoElement.addEventListener('loadeddata', handleLoadedData);

      return () => {
        videoElement.removeEventListener('loadeddata', handleLoadedData);
      };
    }
  }, []);

  return (
    <div className={`relative overflow-hidden flex justify-center items-center h-screen w-screen ${!fadeCompleted ? 'bg-black' : ''}`}>
      <video
        autoPlay
        muted
        playsInline
        preload="auto"
        ref={videoRef}
        className={`absolute transition-opacity event-title-main duration-[2.5s] w-[100vw] h-[100vh] object-cover ease-in-out ${loaded ? 'opacity-100' : 'opacity-0'}`}
      >
        <source src={landing} type="video/webm" />
        Your browser does not support the video tag.
      </video>

      <div className="relative flex justify-center items-center flex-col h-screen w-screen">
        <p className={`xplore transition-opacity duration-[3s] ease-in-out z-20 text-white relative text-8xl mt-3 ${loaded ? 'opacity-100' : 'opacity-0'}`}>
          XPLORE<span className='numbers'>'24</span>
        </p>
      </div>

      <div className="absolute bottom-20 flex justify-end">
        <div className="relative flex flex-col items-center justify-center gap-1">
          <span className="w-7 h-7 block border-r-4 border-b-4 border-white rotate-45 -m-2 rounded animate-custom"></span>
          <span className="w-7 h-7 block border-r-4 border-b-4 border-white rotate-45 -m-2 rounded animate-custom delay-200"></span>
          <span className="w-7 h-7 block border-r-4 border-b-4 border-white rotate-45 -m-2 rounded animate-custom delay-400"></span>
        </div>
      </div>
    </div>
  );
};

export default FadeInImage;
